import { t } from "i18next";
import { API_URL, token_string } from "../constants/config";
import { readCookie, removeCookie, readCookieStartWith } from "./cookie";
export function checkAuth() {
  let authData = { isAuthenticated: false, token: "" };
  try {
    // const token = localStorage.getItem('adminToken');
    const token = readCookie(readCookie(token_string));
    if (!token) {
      throw new Error("Token not found!");
    }

    const tokenSplit = token.split(".");
    if (tokenSplit.length === 3) {
      const userData = JSON.parse(window.atob(tokenSplit[1]));
      authData.isAuthenticated = parseInt(userData.id, 10) === 1;
      authData.token = token;
    }
  } catch (e) {
    console.log("comone", readCookie(token_string));
    console.log("comeone2", readCookie(readCookie(token_string)));
    window.history.replaceState({}, "logout", "/logout");
    window.location = API_URL + "logout";
  }

  return authData;
}

export function logout() {
  try {
    removeCookie(readCookie(token_string));
    removeCookie(token_string);
    // console.log('removeal');
    localStorage.clear();
    document.cookie.split(";").forEach(cookie => {
      const name = cookie.split("=")[0].trim();
      removeCookie(name);
    })
  } catch (e) {
    console.log(e);
  }
}
